class TurfMagikCoverageCalculator extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.input = this.querySelector('[data-coverage-input]');
    this.result = this.querySelector('[data-coverage-result]');
    this.coveragePerPackage = Number.parseFloat(this.dataset.coveragePerPackage);
    this.packageSize = this.dataset.packageSize || '';
    this.packageLabel = this.dataset.packageLabel || 'package';

    if (
      !this.input ||
      !this.result ||
      !Number.isFinite(this.coveragePerPackage) ||
      this.coveragePerPackage <= 0
    ) {
      return;
    }

    this.dataset.ready = 'true';
    this.handleInput = () => this.updateEstimate();
    this.input.addEventListener('input', this.handleInput);
  }

  disconnectedCallback() {
    if (this.input && this.handleInput) this.input.removeEventListener('input', this.handleInput);
    delete this.dataset.ready;
  }

  updateEstimate() {
    const area = Number.parseFloat(this.input.value);
    const pluralLabel = `${this.packageLabel}s`;

    if (this.input.value === '') {
      this.result.textContent = `Enter your area to estimate the number of ${pluralLabel}.`;
      return;
    }

    if (!this.input.checkValidity() || !Number.isFinite(area)) {
      this.result.textContent = 'Enter a whole number from 1 to 1,000,000 sq ft.';
      return;
    }

    const packageCount = Math.ceil(area / this.coveragePerPackage);
    const formattedArea = new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(area);
    const packageWord = packageCount === 1 ? this.packageLabel : pluralLabel;
    const sizeText = this.packageSize ? ` (${this.packageSize} each)` : '';

    this.result.textContent = `Start with ${packageCount} ${packageWord}${sizeText} for ${formattedArea} sq ft.`;
  }
}

if (!customElements.get('turfmagik-coverage-calculator')) {
  customElements.define('turfmagik-coverage-calculator', TurfMagikCoverageCalculator);
}
